module.exports = __webpack_public_path__ + "static/media/icon_link-arrow.f459a10d.svg";